import { combineReducers } from '@reduxjs/toolkit';

import getToken from './get_token';

export default combineReducers({ getToken });